import ajax from '../../lib/ajax'
// Account/GetUserInfoByUserName
// 根据用户名获取用户信息
export async function GetUserInfoByUserName(payload:any) {
    let res = await ajax.get('api/services/app/Account/GetUserInfoByUserName',{params:payload},false)
    return res.data.result
}
// 根据用户名获取用户信息
export async function GetCurrentUserRoleId(payload:any) {
    let res = await ajax.get('api/services/app/Account/GetCurrentUserRoleId',{params:payload},false)
    return res.data.result
}